import React, { memo } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
export function About() {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.5
  }} className="min-h-screen bg-[#000000] selection:bg-[#992f74] selection:text-white pt-20" data-id="element-165">
      <Header data-id="element-166" />
      <main data-id="element-167">
        {/* Hero Section */}
        <section className="relative py-16 px-6 overflow-hidden" data-id="element-168">
          <div className="absolute inset-0 z-0 opacity-20" data-id="element-169">
            <img src="https://cdn.magicpatterns.com/uploads/aDXiLNj2GE1K3JtnCckmmT/pexels-askar-abayev-6192011.jpg" alt="Background Texture" className="w-full h-full object-cover" data-id="element-170" />
            <div className="absolute inset-0 bg-gradient-to-b from-black via-black/80 to-black" data-id="element-171"></div>
          </div>

          <div className="relative z-10 max-w-4xl mx-auto text-center space-y-8" data-id="element-172">
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} className="font-montserrat text-5xl md:text-7xl text-[#992f74] italic" data-id="element-173">
              About Us
            </motion.h1>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2
          }} className="space-y-6 text-white/80 text-lg md:text-xl font-light leading-relaxed" data-id="element-174">
              <p data-id="element-175">
                At{' '}
                <strong className="text-white font-semibold" data-id="element-176">
                  Sips and Nibblez by Zobug
                </strong>
                , we believe every event deserves a taste of luxury. From
                bespoke cocktails and mocktails to gourmet bites and desserts,
                our offerings are thoughtfully curated to delight your guests
                and elevate your celebration.
              </p>
              <p data-id="element-177">
                We blend creativity, premium ingredients, and top-tier
                presentation to deliver not just drinks and food — but a
                memorable experience that feels indulgent, fun, and effortlessly
                sophisticated.
              </p>
              <p className="font-montserrat text-2xl text-[#992f74] italic pt-4" data-id="element-178">
                Because here, pour decisions always taste better.
              </p>
            </motion.div>
          </div>
        </section>

        {/* Core Values Section */}
        <section className="py-16 bg-[#0A0A0A] border-y border-white/5" data-id="element-179">
          <div className="max-w-7xl mx-auto px-6" data-id="element-180">
            <div className="text-center mb-12 space-y-4" data-id="element-181">
              <h2 className="font-montserrat text-4xl md:text-5xl text-[#992f74] italic" data-id="element-182">
                Our Core Values
              </h2>
              <p className="text-white/60 max-w-2xl mx-auto" data-id="element-183">
                At Sips and Nibblez by Zobug, we believe every event deserves a
                taste of luxury. From bespoke cocktails and mocktails to gourmet
                bites and desserts.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-184">
              {[{
              title: 'Excellence in Craft',
              desc: 'We deliver top-tier cocktails, mocktails, and gourmet bites made with precision, creativity, and the finest ingredients.'
            }, {
              title: 'Exceptional Guest Experience',
              desc: 'Every sip and every bite is designed to delight. We prioritize warm service, professionalism, and unforgettable event moments.'
            }, {
              title: 'Innovation & Creativity',
              desc: 'We constantly reinvent flavours, presentation, and experience bringing unique, trend-forward ideas to every event.'
            }, {
              title: 'Reliability & Professionalism',
              desc: 'From timely setup to flawless execution, we are a trusted partner who ensures events run smoothly without stress.'
            }].map((value, idx) => <motion.div key={value.title} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: idx * 0.1
            }} className="bg-black p-8 border border-white/5 hover:border-[#992f74]/30 transition-colors" data-id="element-185">
                  <div className="h-1 w-12 bg-[#992f74] mb-6" data-id="element-186"></div>
                  <h3 className="font-montserrat text-2xl text-white mb-4 italic" data-id="element-187">
                    {value.title}
                  </h3>
                  <p className="text-white/60 leading-relaxed" data-id="element-188">{value.desc}</p>
                </motion.div>)}
            </div>
          </div>
        </section>

        {/* Team Section */}
        <section className="py-16 px-6" data-id="element-189">
          <div className="max-w-7xl mx-auto" data-id="element-190">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-191">
              <div className="space-y-8" data-id="element-192">
                <h2 className="font-montserrat text-4xl md:text-5xl text-[#992f74] italic" data-id="element-193">
                  Meet our amazing team members
                </h2>
                <p className="text-white/80 text-lg leading-relaxed font-light" data-id="element-194">
                  Great events start with a great team and ours brings the
                  flavor, creativity, and energy that make every Sips & Nibblez
                  experience unforgettable. Meet the people who make the magic
                  happen.
                  <div className="pt-8 border-t border-white/10" data-id="element-195">
                    <h3 className="text-2xl text-white font-bold tracking-wide" data-id="element-196">
                      Sharon Cole
                    </h3>
                    <p className="text-[#992f74] uppercase tracking-widest text-sm mt-2" data-id="element-197">
                      Mixologist Sips and Nibblez
                    </p>
                  </div>
                </p>
              </div>
              <div className="relative aspect-[3/4] max-w-md mx-auto lg:ml-auto w-full" data-id="element-198">
                <div className="absolute inset-0 border border-[#992f74]/30 translate-x-4 translate-y-4" data-id="element-199"></div>
                <img src="https://cdn.magicpatterns.com/uploads/psrmPEPk989hdYvZ8GjUJn/Image_(44).jpg" alt="Sharon Cole - Mixologist" className="relative z-10 w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700" data-id="element-200" />
              </div>
            </div>
          </div>
        </section>

        {/* Events Section */}
        <section className="py-16 bg-[#992f74] relative overflow-hidden" data-id="element-201">
          <div className="absolute inset-0 z-0 opacity-10 mix-blend-overlay" data-id="element-202">
            <img src="https://cdn.magicpatterns.com/uploads/aDXiLNj2GE1K3JtnCckmmT/pexels-askar-abayev-6192011.jpg" alt="Background Texture" className="w-full h-full object-cover" data-id="element-203" />
          </div>
          <div className="relative z-10 max-w-4xl mx-auto px-6 text-center space-y-8" data-id="element-204">
            <h2 className="font-montserrat text-4xl md:text-5xl text-white italic" data-id="element-205">
              Some of our Events
            </h2>
            <p className="text-white/90 text-lg leading-relaxed font-light" data-id="element-206">
              At Sips & Nibblez, we create events that keep guests engaged from
              start to finish. Our live mixology sessions, tasting and pairing
              experiences, and interactive cocktail bar moments bring energy and
              excitement to any gathering. Guests stay entertained with
              beautifully crafted drinks made on the spot, flavorful bites
              served throughout the event, and immersive themed nights that
              transform the entire atmosphere. Whether it's a birthday,
              corporate mixer, or private celebration, we deliver a dynamic,
              memorable experience that keeps people talking long after the
              event ends.
            </p>
          </div>
        </section>
      </main>
      <Footer data-id="element-207" />
    </motion.div>;
}